import { render } from "./NewOrganizationForm.vue?vue&type=template&id=40f2c2a6"
import script from "./NewOrganizationForm.vue?vue&type=script&lang=js"
export * from "./NewOrganizationForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__